module.exports = require("./iu-Latn.js");